import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export const SaveKardAttribution = gql`
  mutation SaveKardAttributionEvent($input: SaveKardAttributionEventInput!) {
    saveKardAttributionEvent(input: $input) {
      ... on SaveKardAttributionEventSuccess {
        __typename
        success
      }
      ... on SaveKardAttributionEventError {
        __typename
        ...error
      }
    }
  }
  ${error}
`;

export default SaveKardAttribution;
